import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ArrowIcon } from "../../../../assets/Icons/arrownext.svg";
import ShowCard from "../../../../Components/ShowCard/GaiaCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { rowItemCount } from "../../../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useWindowWidth } from "@react-hook/window-size";
import MagazineCard from "../../../../Components/MagazineCard/MagazineCard";
import ShortsCard from "../../../Shorts/ShortsCard";
import { navigateToCategory } from "../../../../utils/utils";
import Translate from "../../../../Components/Multilanguage/Translate";

const GaiaCategories = ({ data, onRemoveItem }) => {
  const windowSize = useWindowWidth();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const pubid = projectInfo?.projectConfig?.pubid || projectInfo?.pubid;
  const isFlsTv = pubid == 50183;
  const isYowTv = pubid == 50187;
  const enableCustomRowCount = true;
  const visibleItemsCount = (enableCustomRowCount && data?.visible_items_count) ? Math.ceil(Number(data.visible_items_count)) : null;

  const initialConfigCount = visibleItemsCount ?? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ?? 5;
  const initialRowClass = rowItemCount(Number(initialConfigCount)) || "rowCount5";
  const initialRowCountNumber = parseInt(initialRowClass.replace(/\D/g, ""), 10) || 5;

  const [activeIndex, setActiveIndex] = useState(0);
  const [rowItemsClass, setRowItemsClass] = useState(initialRowClass);
  const [rowItemCountNumber, setRowItemCountNumber] = useState(initialRowCountNumber);
  const effectiveCount = (enableCustomRowCount ? visibleItemsCount : null) ?? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT;
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const portraitFallback = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ?? 7;
  const landscapeFallback = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ?? 5;
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const thumbnailOrientation = (data?.type === "TOP_TRENDING") 
    ? "LANDSCAPE" 
    : (data?.thumbnail_orientation ? data?.thumbnail_orientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION);
  const count = data?.shows?.length;
  const [displayedData, setDisplayedData] = useState(data?.shows || []);
  const isSingleCard = data?.shows?.length === 1;

  const onSlideChange = (swiper) => {
    const lastSlideIndex = swiper.activeIndex + (swiper.params.slidesPerView - 1);

    if (lastSlideIndex >= swiper.slides.length) {
      setActiveIndex(swiper.slides.length - 1);
    } else {
      setActiveIndex(lastSlideIndex);
    }
  };

  const handleRemoveItem = (videoIdToRemove) => {
    setDisplayedData(prevData => {
      const updated = prevData.filter(item => item.video_id !== videoIdToRemove);
      if (onRemoveItem) {
        onRemoveItem(data?.id || data?.category_name, videoIdToRemove);
      }
      return updated;
    });
  };
  const handleSwiperInit = (swiperInstance) => {
    swiperRef.current = swiperInstance;
    if (isYowTv && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
    onSlideChange(swiperInstance);
  };
  // useEffect(() => {
  //   if(windowSize>980){
  //     if(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT){
  //       setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT))
  //     }else {
  //       setRowItemsClass("rowCount5");
  //     }
  //   } else {
  //     setRowItemsClass("rowCount5");
  //   }
  //   setRowItemCountNumber(parseInt(rowItemsClass.replace(/\D/g, ''), 10));
  // }, [projectInfo,windowSize]);
  useEffect(() => {
    if (windowSize > 1200) {
      if (data?.type === 'SHORTS') {
        setRowItemCountNumber(5);
      }
    }
    if (windowSize > 980) {
      const configCount = (enableCustomRowCount ? visibleItemsCount : null) ?? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT;
      const newClass = configCount ? rowItemCount(configCount) : "rowCount5";
      setRowItemsClass(newClass);
      setRowItemCountNumber(parseInt(newClass.replace(/\D/g, ''), 10));
      if (data?.type === 'FASTCHANNELS') {
        setRowItemCountNumber(9);
      }
      if (data?.type === 'SHORTS') {
        setRowItemCountNumber(4);
      }
    } else {
      setRowItemsClass("rowCount5");
      if (windowSize <= 360) {
        if (thumbnailOrientation === "PORTRAIT") {
          setRowItemCountNumber(3);
        } else {
          setRowItemCountNumber(2);
        }
      }
      else if (windowSize > 767) {
        setRowItemCountNumber(3);
      } else if (windowSize > 479) {
        setRowItemCountNumber(2);
      } else if (windowSize > 319) {
        setRowItemCountNumber(1);
      }
      if (data?.type === 'FASTCHANNELS') {
        if (windowSize > 767) {
          setRowItemCountNumber(4);
        } else if (windowSize > 319) {
          setRowItemCountNumber(3);
        }
      }
    }
  }, [projectInfo, windowSize]);

  const itemsToRender = (isRTL && count > rowItemCountNumber) ? [...displayedData].reverse() : displayedData;
  console.log(windowSize, "windowSize ");

  return (
    <div
      className={`gaiaCategoriesContainer ${isFlsTv ? "fls-tv-categories" : ""} ${isYowTv ? "yowtv-categories" : ""} ${data?.type === "TOP_TRENDING" ? "top-trending-row" : ""} pubid-${projectInfo?.projectConfig?.pubid} ${projectInfo?.projectConfig?.pubid == 50183 ? "pubid-50183" : ""} ${projectInfo?.projectConfig?.pubid == 50187 ? "pubid-50187" : ""} ${isRTL ? (
        count > rowItemCountNumber
          ? "ltr"
          : windowSize < 980
            ? "rtl"
            : "rtl"
      ) : (
        ""
      )}`}
      role="region"
      aria-label="Categories Section"
    >
      <div className="header-row">
        <div className="header">
          <h1>{data?.category_name}</h1>
        </div>
        {data?.show_all_needed && (
          <div className="view-all"
            onClick={() => navigateToCategory(navigate, data, thumbnailOrientation)}
            role="button"
            tabIndex={0}
            aria-label={`View all ${data?.category_name}`}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategory(navigate, data, thumbnailOrientation); }}
          >
            <Translate textKey={'view_all'} />
            <ArrowIcon className="arrow-icon" />
          </div>
        )}
      </div>
      <div className="wrapper" style={{ position: 'relative' }}>
        <Swiper
          key={isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl") : ""}
          modules={[Navigation]}
          spaceBetween={10}
          slidesPerView={5}
          slidesPerGroup={5}
          navigation={isYowTv ? {
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          } : true}
          onBeforeInit={(swiper) => {
            if (isYowTv) {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }
          }}
          onSlideChange={onSlideChange}
          watchSlidesProgress
          loop={false}
          onSwiper={handleSwiperInit}
          initialSlide={(isRTL && count > rowItemCountNumber) ? count - 1 : 0}
          className={thumbnailOrientation === `PORTRAIT` ? `items portrait ${rowItemsClass}` : `items landscape ${rowItemsClass}`}
          breakpoints={{
            320: {
              slidesPerView: isYowTv
                ? (data?.type === "TOP_TRENDING" ? 1.3 : (thumbnailOrientation === "PORTRAIT" ? 2.2 : 1.3))
                : (thumbnailOrientation === "PORTRAIT" ? 3 : 2),
              slidesPerGroup: 1,
              spaceBetween: isYowTv ? (data?.type === "TOP_TRENDING" ? 30 : 12) : 20,
            },
            480: {
              slidesPerView: isYowTv
                ? (data?.type === "TOP_TRENDING" ? 1.6 : (thumbnailOrientation === "PORTRAIT" ? 2.6 : 1.6))
                : (data?.type == 'FASTCHANNELS' ? 3 : 2),
              slidesPerGroup: 1,
              spaceBetween: isYowTv ? (data?.type === "TOP_TRENDING" ? 36 : 12) : 20,
            },
            768: {
              slidesPerView: isYowTv
                ? (data?.type === "TOP_TRENDING" ? 2.3 : (thumbnailOrientation === "PORTRAIT" ? 3.5 : 2.4))
                : (data?.type == 'FASTCHANNELS' ? 4 : 3),
              slidesPerGroup: 1,
              spaceBetween: isYowTv ? (data?.type === "TOP_TRENDING" ? 44 : 14) : 20,
            },
            980: {
              slidesPerView: (isYowTv && data?.type === "TOP_TRENDING")
                ? 2.8
                : (data?.type === 'SHORTS' ? 4 : data?.type == 'FASTCHANNELS' ? 9 : effectiveCount ? effectiveCount : 4),
              slidesPerGroup: (isYowTv && data?.type === "TOP_TRENDING")
                ? 1
                : (data?.type === 'SHORTS' ? 4 : data?.type == 'FASTCHANNELS' ? 9 : effectiveCount ? Number(effectiveCount) : 4),
              spaceBetween: data?.type === 'SHORTS' ? 10 : (isYowTv && data?.type === "TOP_TRENDING" ? 52 : 20),
            },
            1200: {
              slidesPerView: (isYowTv && data?.type === "TOP_TRENDING")
                ? 3.5
                : (data?.type === 'SHORTS'
                  ? 5
                  : data?.type == 'FASTCHANNELS'
                    ? 9
                    : projectInfo?.projectConfig?.pubid === 50134
                      ? (thumbnailOrientation === 'PORTRAIT' ? 6 : 4)
                      : (thumbnailOrientation === 'PORTRAIT' ? (effectiveCount ?? portraitFallback) : (effectiveCount ?? landscapeFallback))),
              slidesPerGroup: (isYowTv && data?.type === "TOP_TRENDING")
                ? 1
                : (data?.type === 'SHORTS'
                  ? 5
                  : data?.type == 'FASTCHANNELS'
                    ? 9
                    : projectInfo?.projectConfig?.pubid === 50134
                      ? (thumbnailOrientation === 'PORTRAIT' ? 6 : 4)
                      : (thumbnailOrientation === 'PORTRAIT' ? Number(effectiveCount ?? portraitFallback) : Number(effectiveCount ?? landscapeFallback))),
              spaceBetween: data?.type === 'SHORTS' ? 10 : (isYowTv && data?.type === "TOP_TRENDING" ? 60 : 20),
            },
          }}
          aria-label="Categories Carousel"
        >
          {itemsToRender?.map((item, index) => (
            <SwiperSlide key={index} className={`${!isYowTv && !isSingleCard && index === activeIndex ? "translate-last" : ""} ${data?.type === "SHORTS" ? "no-transform" : ""}`} aria-label={`Category Slide ${index + 1}`}>
              <div className={data?.type === "SHORTS" ? "shortsCardContainer" : "show"}>
                {data?.type === "MAGAZINES" ? (
                  <MagazineCard
                    data={item}
                    url={data.url}
                    metaData={true}
                    cardHover={true}
                    isPriority={index < rowItemCountNumber}
                  />
                ) : data?.type === "SHORTS" ? (
                  <ShortsCard
                    data={item}
                    season={false}
                    metaData={true}
                    type={data?.type}
                    vanityUrl={item?.vanity_url}
                    isPriority={index < rowItemCountNumber}
                  />
                ) : (
                  <ShowCard
                    data={item}
                    season={false}
                    metaData={true}
                    type={data?.type}
                    thumbnailOrientation={thumbnailOrientation}
                    displayedData={displayedData}
                    onRemove={handleRemoveItem}
                    rankIndex={data?.type === "TOP_TRENDING" ? index + 1 : undefined}
                    isPriority={index < rowItemCountNumber}
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {isYowTv && (
          <div className="yow-category-controls">
            <button
              ref={prevRef}
              className="yow-category-prev swiper-button-prev"
              aria-label="Previous slide"
              onClick={(e) => {
                e.stopPropagation();
                if (swiperRef.current) {
                  swiperRef.current.slidePrev();
                }
              }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 3.75L6.25 10L12.5 16.25" stroke="#0D0D0C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button
              ref={nextRef}
              className="yow-category-next swiper-button-next"
              aria-label="Next slide"
              onClick={(e) => {
                e.stopPropagation();
                if (swiperRef.current) {
                  swiperRef.current.slideNext();
                }
              }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="#0D0D0C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        )}
      </div>
      {data?.show_all_needed && (
        <div className="view-all-mobile"
          onClick={() => navigateToCategory(navigate, data, thumbnailOrientation)}
          role="button"
          tabIndex={0}
          aria-label={`View all ${data?.category_name}`}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategory(navigate, data, thumbnailOrientation); }}
        >
          <Translate textKey={'view_all'} />
          <ArrowIcon className="arrow-icon" />
        </div>
      )}
    </div>
  );
};

export default GaiaCategories;
